import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { isNative, secureStorage } from '../utils/capacitor';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate('/auth', { replace: true });
        return;
      }

      const sessionId = match[1];

      try {
        const response = await api.post('/auth/google/session', { session_id: sessionId });
        const { access_token, user } = response.data;

        const expiry = String(Date.now() + 24 * 60 * 60 * 1000);
        localStorage.setItem('token', access_token);
        localStorage.setItem('token_expiry', expiry);
        if (isNative) {
          await secureStorage.set('token', access_token);
          await secureStorage.set('token_expiry', expiry);
        }

        setUser(user);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch {
        navigate('/auth', { replace: true });
      }
    };

    processGoogleAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-teal-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-teal-600 mx-auto mb-4" />
        <p className="text-gray-600 text-sm">Signing you in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
